module.exports = __webpack_public_path__ + "static/media/ln.9130a670.svg";